import { render } from "./IconLink.vue?vue&type=template&id=5b37c102"
import script from "./IconLink.vue?vue&type=script&lang=js"
export * from "./IconLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__